import React, { Component } from "react";
import InputMask from 'react-input-mask';
import { translate } from 'react-i18next';
import { request } from "../../../../config";

class SetPassword extends Component {

  state = {
    openPin: false,
    feedbackMessage: null,
    openSuccess: false,
    isDisabled: true,
    isPasswordVisibility: false,
    isRepeatPasswordVisibility: false,
    allRequirementsMet: false,
    passwordRequirements: {
      hasLength: false,
      hasUppercase: false,
      hasLowercase: false,
      hasNumber: false,
      hasSpecial: false,
    }
  }

  validatePasswordRequirements = (password) => {
    const requirements = {
      hasLength: password.length >= 8,
      hasUppercase: /[A-Z]/.test(password),
      hasLowercase: /[a-z]/.test(password),
      hasNumber: /[0-9]/.test(password),
      hasSpecial: /[!@#$%^&*()_+\-=[\]{}|;:'",./<>?\\`~]/.test(password),
    };
    return requirements;
  }

  validateData = (inputType, event) => {
    // let regex = /^[a-zA-Z\d]{8,}$/
    this.setState({ checkedData: false, feedbackMessage: null });
    if (inputType === 'phoneNumber') {
      setTimeout(() => {
        if (this.phoneNumber.value.indexOf("_") === -1) {
          this.setState({ validatePhoneNumber: true });
        }
        else {
          this.setState({ validatePhoneNumber: false });
        }
      }, 1)
    }
    else if (inputType === 'password' || inputType === 'repeatPassword') {
      setTimeout(() => {
        // if (this.password.value.trim() !== "" && this.password.value.match(regex) && this.password.value === this.repeatPassword.value) {
        //   this.setState({ validatePassword: true });
        // }
        // else {
        //   this.setState({ validatePassword: false });
        // }
        this.setState({ feedbackMessage: null });
        const password = this.password.value.trim();
        const repeatPassword = this.repeatPassword.value.trim();

        const requirements = this.validatePasswordRequirements(password);
        const allRequirementsMet = Object.values(requirements).every(req => req === true);

        if (password !== "" && repeatPassword !== "" && password === repeatPassword && allRequirementsMet) {
          this.setState({ validatePassword: true, passwordRequirements: requirements, allRequirementsMet });
        }
        else {
          this.setState({ validatePassword: false, passwordRequirements: requirements, allRequirementsMet });
        }
      }, 1)
    }
    setTimeout(() => {
      if (this.state.validatePassword && (this.props.location.pathname.includes('/sima') ? this.state.validatePhoneNumber : true)) {
        this.setState({ isDisabled: false });
      }
      else {
        this.setState({ isDisabled: true });
      }
    }, 1);
  }

  // checkIsNotNull = () => {
  //   this.setState({ feedbackMessage: null });
  //   if (this.password.value.trim() !== "" && this.password.value.match(regex) && this.repeatPassword.value.trim() !== "" && this.repeatPassword.value.match(regex)) {
  //     this.setState({ isDisabled: false });
  //   }
  //   else {
  //     this.setState({ isDisabled: true });
  //   }
  // }

  setPasswordVisibility = (name) => {
    this.setState({ [name]: !this.state[name] });
  }

  registerAsan = () => {
    this.props.updateAppState('isLoadingTransparentBackground', true);
    let registerIndividualAsanRequestBody = {
      password: this.password.value,
      repeatPassword: this.repeatPassword.value,
      token: this.props.location.state.token
    };
    fetch(request(`register/${this.props.location.pathname.includes('/juridical') ? "registrationJuridicalForAsan" : "registerIndividualAsanv1"}`, registerIndividualAsanRequestBody))
      .then(res => res.json())
      .then((registerIndividualAsanResponse) => {
        if (registerIndividualAsanResponse.status.statusCode !== 1) {
          this.setState({ feedbackMessage: this.props.t(registerIndividualAsanResponse.status.statusCode) });
          this.props.updateAppState('isLoadingTransparentBackground', false);
        }
        else {
          this.props.updateAppState('isLoadingTransparentBackground', false);
          this.props.history.push('/sign-up/not-a-bank-customer', { success: true });
        }
      },
        (error) => {
          this.props.history.push("/technical-break");
        });
  }

  // registerSimaSendOtp = () => {
  //   this.props.updateAppState('isLoadingTransparentBackground', true);
  //   let registerSimaSendOtpRequestBody = {
  //     // password: this.password.value,
  //     // repeatPassword: this.repeatPassword.value,
  //     mobile: this.phoneNumber.value,
  //     token: this.props.location.state.token,
  //     lang: localStorage.getItem('i18nextLng').toUpperCase(),
  //   };
  //   fetch(request("register/simaRegisterSendOtp", registerSimaSendOtpRequestBody))
  //     .then(res => res.json())
  //     .then((registerSimaSendOtpResponse) => {
  //       if (registerSimaSendOtpResponse.status.statusCode !== 1) {
  //         this.setState({ feedbackMessage: this.props.t(registerSimaSendOtpResponse.status.statusCode) });
  //         this.props.updateAppState('isLoadingTransparentBackground', false);
  //       }
  //       else {
  //         this.props.updateAppState('isLoadingTransparentBackground', false);
  //         this.setState({ token: registerSimaSendOtpResponse.verifyToken });
  //       }
  //     },
  //       (error) => {
  //         this.props.history.push("/technical-break");
  //       });
  // }

  // simaRegisterVerifyOtp = (e, confirmCode) => {
  //   e.preventDefault();
  //   this.props.updateAppState('isLoadingTransparentBackground', true);
  //   let simaRegisterVerifyOtpRequestBody = {
  //     password: this.password.value,
  //     repeatPassword: this.repeatPassword.value,
  //     confirmCode: confirmCode,
  //     token: this.state.token,
  //     lang: localStorage.getItem('i18nextLng').toUpperCase(),
  //   };
  //   fetch(request("register/simaRegisterVerifyOtp", simaRegisterVerifyOtpRequestBody))
  //     .then(res => res.json())
  //     .then((simaRegisterVerifyOtpResponse) => {
  //       if (simaRegisterVerifyOtpResponse.status.statusCode !== 1) {
  //         this.setState({ feedbackMessage: this.props.t(simaRegisterVerifyOtpResponse.status.statusCode) });
  //         this.props.updateAppState('isLoadingTransparentBackground', false);
  //       }
  //       else {
  //         this.props.updateAppState('isLoadingTransparentBackground', false);
  //         this.props.history.push("/sign-up/not-a-bank-customer", { success: true });
  //       }
  //     },
  //       (error) => {
  //         this.props.history.push("/technical-break");
  //       });
  // }

  componentDidMount() {
    if (!this.props.location.state?.token) {
      this.props.history.push("/sign-up/not-a-bank-customer");
    }
  }

  getPhoneNumber = (phoneNumber) => {
    ['+', '-', '(', ')', ' '].forEach((char) => {
      while (phoneNumber.indexOf(char) !== -1) {
        phoneNumber =
          phoneNumber.slice(0, phoneNumber.indexOf(char)) +
          phoneNumber.slice(phoneNumber.indexOf(char) + 1, phoneNumber.length);
      }
    });
    return phoneNumber;
  };

  submit = (event) => {
    event.preventDefault();
    if (this.props.location.pathname.includes("/sima")) {
      this.props.history.push("/sign-up/not-a-bank-customer/otp", {
        password: this.password.value, repeatPassword: this.repeatPassword.value,
        phoneNumber: this.getPhoneNumber(this.phoneNumber.value), token: this.props.location.state.token
      })
    } else {
      this.registerAsan()
    }
  }

  render() {
    let { isPasswordVisibility, isRepeatPasswordVisibility, feedbackMessage, isDisabled, passwordRequirements } = this.state;
    let { t, location } = this.props;
    const requiredMap = {
      hasLength: t('At least 8 characters'),
      hasUppercase: t('One uppercase letter'),
      hasLowercase: t('One lowercase letter'),
      hasNumber: t('One number'),
      hasSpecial: t('One special character'),
    };
    return (
      <form>
        <div className="registration-container-form">
          {location.pathname.includes("/sima") &&
            <div className="header-sign-section-container-form-group">
              <label className="registration-container-form-group-label">{t('phone number')}</label>
              <div className="registration-container-form-group-box">
                <InputMask mask="+\9\9\4 99 999-99-99" className="header-sign-section-container-form-group-box-input header-sign-section-container-form-group-box-input-new" placeholder="+994 XX XXX XX XX" ref={(input) => { this.phoneNumber = input }} onInput={this.validateData.bind(this, 'phoneNumber')} />
              </div>
            </div>}
          <div className="registration-container-form-group" onClick={this.setPasswordVisibility}>
            <label className="header-sign-section-container-form-group-label">{t('Set a password for login')}</label>
            <label className="registration-container-form-group-label">{t('password')}</label>
            <div className="registration-container-form-group-box">
              <abbr title={t('The password must be at least 8 characters long and include both letters and numbers.')}>
                <input type={"text"} autoComplete="off" className={`registration-container-form-group-box-input ${isPasswordVisibility === false && "registration-container-form-group-box-input-password"}`} placeholder={t('enter the password')} ref={(input) => { this.password = input }} onInput={this.validateData.bind(this, 'password')} />
              </abbr>
              <div className="registration-container-form-group-box-icon registration-container-form-group-box-icon-new" onClick={this.setPasswordVisibility.bind(this, 'isPasswordVisibility')}>
                {
                  isPasswordVisibility === false ?
                    <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg" className="registration-container-form-group-box-icon-img registration-container-form-group-box-icon-img__password">
                      <path d="M8.01391 2.29167C7.76348 2.32031 7.37391 2.3776 7.12348 2.4349C7.23478 2.63542 7.31826 3.00781 7.34609 3.20833C7.34609 4.09635 6.62261 4.8125 5.78783 4.8125C5.56522 4.8125 5.20348 4.72656 5.03652 4.61198C4.95304 4.86979 4.89739 5.24219 4.89739 5.5C4.89739 7.27604 6.2887 8.70833 8.01391 8.70833C9.73913 8.70833 11.1304 7.27604 11.1304 5.5C11.1304 3.7526 9.73913 2.29167 8.01391 2.29167ZM15.9165 5.09896C14.4139 2.0625 11.4087 0 8.01391 0C4.5913 0 1.58609 2.0625 0.0834783 5.09896C0.0278261 5.21354 0 5.38542 0 5.52865C0 5.64323 0.0278261 5.8151 0.0834783 5.92969C1.58609 8.96615 4.5913 11 8.01391 11C11.4087 11 14.4139 8.96615 15.9165 5.92969C15.9722 5.8151 16 5.64323 16 5.5C16 5.38542 15.9722 5.21354 15.9165 5.09896ZM8.01391 9.625C5.25913 9.625 2.72696 8.04948 1.3913 5.5C2.72696 2.95052 5.25913 1.375 8.01391 1.375C10.7409 1.375 13.273 2.95052 14.6087 5.5C13.273 8.04948 10.7409 9.625 8.01391 9.625Z" fill="#BDC3C7" />
                    </svg>
                    :
                    <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="registration-container-form-group-box-icon-img registration-container-form-group-box-icon-img__password-slash">
                      <path d="M15.8502 11.0391L0.923557 0.09375C0.848674 0.046875 0.74883 0 0.673947 0C0.549142 0 0.424337 0.0703125 0.349454 0.140625L0.099844 0.445312C0.049922 0.492188 0 0.609375 0 0.679688C0 0.773438 0.074883 0.914062 0.174727 0.960938L15.1014 11.9297C15.1513 11.9766 15.2512 12 15.351 12C15.4509 12 15.5757 11.9531 15.6505 11.8594L15.9002 11.5781C15.9501 11.5312 16 11.4141 16 11.3438C16 11.25 15.9251 11.1094 15.8502 11.0391ZM7.41342 3.44531L10.7832 5.90625C10.7332 4.5 9.51014 3.375 8.01248 3.375C7.83775 3.39844 7.58814 3.42188 7.41342 3.44531ZM8.58658 8.57812L5.21685 6.11719C5.26677 7.52344 6.48986 8.625 8.01248 8.625C8.16225 8.625 8.41186 8.60156 8.58658 8.57812ZM8.01248 2.625C10.4587 2.625 12.7301 3.91406 13.9282 6C13.6786 6.44531 13.2044 7.07812 12.83 7.42969L13.7785 8.10938C14.2278 7.66406 14.8019 6.89062 15.1014 6.35156C15.1513 6.25781 15.2012 6.11719 15.2012 6C15.2012 5.90625 15.1513 5.76562 15.1014 5.67188C13.7535 3.1875 11.0577 1.5 8.01248 1.5C7.08892 1.5 6.21529 1.66406 5.39158 1.94531L6.53978 2.8125C7.01404 2.69531 7.51326 2.625 8.01248 2.625ZM8.01248 9.375C5.54134 9.375 3.26989 8.08594 2.07176 6C2.32137 5.57812 2.79563 4.94531 3.17005 4.59375L2.22153 3.91406C1.77223 4.35938 1.19813 5.13281 0.898596 5.67188C0.848674 5.76562 0.823713 5.90625 0.823713 6.02344C0.823713 6.11719 0.848674 6.25781 0.898596 6.35156C2.24649 8.83594 4.94228 10.5 8.01248 10.5C8.91108 10.5 9.78471 10.3359 10.6084 10.0781L9.46022 9.21094C8.98596 9.32812 8.48674 9.375 8.01248 9.375Z" fill="#BDC3C7" />
                    </svg>
                }
              </div>
            </div>
            <div style={{ marginTop: '16px' }}>
              {Object.entries(requiredMap).map(([key, label]) => (
                <div key={key} className="registration-container-form-group-label" style={{ display: 'flex', alignItems: 'center', color: passwordRequirements[key] ? '#16A34A' : '#9CA3AF' }}>
                  <span style={{ marginRight: '8px' }}>{passwordRequirements[key] ? '✓' : '𐤏'}</span>
                  <span>{label}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="registration-container-form-group" onClick={this.setPasswordVisibility}>
            <label className="registration-container-form-group-label">{t('repeat password')}</label>
            <div className="registration-container-form-group-box">
              <input type={"text"} autoComplete="off" className={`registration-container-form-group-box-input ${isRepeatPasswordVisibility === false && "registration-container-form-group-box-input-password"}`} placeholder={t('enter the password again')} ref={(input) => { this.repeatPassword = input }} onInput={this.validateData.bind(this, 'repeatPassword')} />
              <div className="registration-container-form-group-box-icon registration-container-form-group-box-icon-new" onClick={this.setPasswordVisibility.bind(this, 'isRepeatPasswordVisibility')}>
                {
                  isRepeatPasswordVisibility === false ?
                    <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg" className="registration-container-form-group-box-icon-img registration-container-form-group-box-icon-img__password">
                      <path d="M8.01391 2.29167C7.76348 2.32031 7.37391 2.3776 7.12348 2.4349C7.23478 2.63542 7.31826 3.00781 7.34609 3.20833C7.34609 4.09635 6.62261 4.8125 5.78783 4.8125C5.56522 4.8125 5.20348 4.72656 5.03652 4.61198C4.95304 4.86979 4.89739 5.24219 4.89739 5.5C4.89739 7.27604 6.2887 8.70833 8.01391 8.70833C9.73913 8.70833 11.1304 7.27604 11.1304 5.5C11.1304 3.7526 9.73913 2.29167 8.01391 2.29167ZM15.9165 5.09896C14.4139 2.0625 11.4087 0 8.01391 0C4.5913 0 1.58609 2.0625 0.0834783 5.09896C0.0278261 5.21354 0 5.38542 0 5.52865C0 5.64323 0.0278261 5.8151 0.0834783 5.92969C1.58609 8.96615 4.5913 11 8.01391 11C11.4087 11 14.4139 8.96615 15.9165 5.92969C15.9722 5.8151 16 5.64323 16 5.5C16 5.38542 15.9722 5.21354 15.9165 5.09896ZM8.01391 9.625C5.25913 9.625 2.72696 8.04948 1.3913 5.5C2.72696 2.95052 5.25913 1.375 8.01391 1.375C10.7409 1.375 13.273 2.95052 14.6087 5.5C13.273 8.04948 10.7409 9.625 8.01391 9.625Z" fill="#BDC3C7" />
                    </svg>
                    :
                    <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="registration-container-form-group-box-icon-img registration-container-form-group-box-icon-img__password-slash">
                      <path d="M15.8502 11.0391L0.923557 0.09375C0.848674 0.046875 0.74883 0 0.673947 0C0.549142 0 0.424337 0.0703125 0.349454 0.140625L0.099844 0.445312C0.049922 0.492188 0 0.609375 0 0.679688C0 0.773438 0.074883 0.914062 0.174727 0.960938L15.1014 11.9297C15.1513 11.9766 15.2512 12 15.351 12C15.4509 12 15.5757 11.9531 15.6505 11.8594L15.9002 11.5781C15.9501 11.5312 16 11.4141 16 11.3438C16 11.25 15.9251 11.1094 15.8502 11.0391ZM7.41342 3.44531L10.7832 5.90625C10.7332 4.5 9.51014 3.375 8.01248 3.375C7.83775 3.39844 7.58814 3.42188 7.41342 3.44531ZM8.58658 8.57812L5.21685 6.11719C5.26677 7.52344 6.48986 8.625 8.01248 8.625C8.16225 8.625 8.41186 8.60156 8.58658 8.57812ZM8.01248 2.625C10.4587 2.625 12.7301 3.91406 13.9282 6C13.6786 6.44531 13.2044 7.07812 12.83 7.42969L13.7785 8.10938C14.2278 7.66406 14.8019 6.89062 15.1014 6.35156C15.1513 6.25781 15.2012 6.11719 15.2012 6C15.2012 5.90625 15.1513 5.76562 15.1014 5.67188C13.7535 3.1875 11.0577 1.5 8.01248 1.5C7.08892 1.5 6.21529 1.66406 5.39158 1.94531L6.53978 2.8125C7.01404 2.69531 7.51326 2.625 8.01248 2.625ZM8.01248 9.375C5.54134 9.375 3.26989 8.08594 2.07176 6C2.32137 5.57812 2.79563 4.94531 3.17005 4.59375L2.22153 3.91406C1.77223 4.35938 1.19813 5.13281 0.898596 5.67188C0.848674 5.76562 0.823713 5.90625 0.823713 6.02344C0.823713 6.11719 0.848674 6.25781 0.898596 6.35156C2.24649 8.83594 4.94228 10.5 8.01248 10.5C8.91108 10.5 9.78471 10.3359 10.6084 10.0781L9.46022 9.21094C8.98596 9.32812 8.48674 9.375 8.01248 9.375Z" fill="#BDC3C7" />
                    </svg>
                }
              </div>
            </div>
          </div>
        </div>
        <div className="registration-container-validation-feedback">
          {
            feedbackMessage ? <p className="registration-container-validation-feedback-message">{feedbackMessage}</p> : null
          }
        </div>
        <button className="header-sign-section-container-form-button" type="button" disabled={isDisabled} onClick={this.submit}>{t('continue')}</button>
      </form>
    )
  };
};

export default translate("translation")(SetPassword);